<template>
  <v-container fluid>
    <div>
      <h2 v-if="$route.query.unregistered" class="d-none d-sm-block">
        {{ $tc('location') }}
        <span class="sub-title">{{ $route.query.code }}</span>
      </h2>
      <h2 v-else>
        {{ $t('new_location') }}
      </h2>
      <location-form></location-form>
    </div>
  </v-container>

</template>

<script>

import LocationForm from '@/components/location/LocationForm'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  name: 'LocationCreate',
  components: { LocationForm },
  mixins: [BrowserUtilitiesMixin],
  mounted () {
    const title = this.$route.query.unregistered ? `${this.$tc('location')} ${this.$route.query.code}` : this.$t('new_location')
    this.updateBrowserTitle(title)
  }
}

</script>

<style scoped>
    .sub-title {
        font-size: 65%;
        color: #777777;
    }
</style>
